import { EntityFactoryFactory } from 'src/services/entity-factory/EntityFactoryFactory';
import User from 'src/entities/User';
import JuridicalPerson from 'src/entities/JuridicalPerson';
import PhysicalPerson from 'src/entities/PhysicalPerson';
import Project from 'src/entities/Project';
import Company from 'src/entities/Company';
import InvestorType from 'src/entities/InvestorType';
import Test from 'src/entities/AptitudeTest';
import TestChoice from 'src/entities/AptitudeTestChoice';
import TestQuestion from 'src/entities/AptitudeTestQuestion';
import TestSection from 'src/entities/AptitudeTestSection';
import FilledTest from 'src/entities/FilledAptitudeTest';
import FilledTestSection from 'src/entities/FilledAptitudeTestSection';
import FilledTestQuestion from 'src/entities/FilledAptitudeTestQuestion';
import Metrics from 'src/entities/Metrics';
import ProjectChildComment from 'src/entities/ProjectChildComment';
import ProjectComment from 'src/entities/ProjectComment';
import Investment from 'src/entities/Investment';
import SectorOfInterest from 'src/entities/SectorOfInterest';
import InvestorDeck from 'src/entities/InvestorDeck';
import Person from 'src/entities/Person';
import ContractCorrections from 'src/value-objects/ContractCorrections';
import ProjectImage from 'src/entities/ProjectImage';
import ProjectTeamMember from 'src/value-objects/ProjectTeamMembers';
import OfflineInvestor from 'src/entities/OfflineInvestor';
import QuarterlyReport from 'src/entities/QuarterlyReport';
import HomeBanner from 'src/entities/HomeBanner';
import Testimonial from 'src/entities/Testimonial';

export type Entity = User | JuridicalPerson | PhysicalPerson | InvestorType | Project | Company | Test |
  TestSection | TestQuestion | TestChoice | FilledTest | FilledTestSection | FilledTestQuestion | Metrics |
  ProjectComment | ProjectChildComment | Investment | SectorOfInterest | Person |
  ContractCorrections | ProjectImage | ProjectTeamMember | OfflineInvestor | InvestorDeck | QuarterlyReport |
  HomeBanner | Testimonial;

export interface ClassOf<T extends Entity> {
  new(args: T): T;
}

export interface FactoryInterface<T extends Entity> {
  toEntity(args: {}): {};

  toRequest(entity: T): {};
}

export abstract class BaseFactory<T extends Entity> implements FactoryInterface<T> {
  protected entityFactoryFactory: EntityFactoryFactory;

  constructor(entityFactoryFactory: EntityFactoryFactory) {
    this.entityFactoryFactory = entityFactoryFactory;
  }

  toEntity(args: {}): T {
    throw 'Method not defined';
  }

  toRequest(entity: T): {} {
    throw 'Method not defined';
  }
}



// WEBPACK FOOTER //
// ./src/services/entity-factory/FactoryInterface.tsx